import {NgModule} from '@angular/core';
import {Route, Router, Routes, RouterModule} from '@angular/router';
import {NamedRoutesService} from 'ng-named-routes';

import {HomeComponent} from './home/home.component';
import {DataComponent} from './data/data.component';
import {DataDownloadComponent} from './data-download/data-download.component';
import {DataPlotComponent} from './data-plot/data-plot.component';
import {DataPlotInteractiveComponent} from "./data-plot-interactive/data-plot-interactive.component";
import {DeploymentsComponent} from './deployments/deployments.component';
import {DeploymentsAllComponent} from './deployments-all/deployments-all.component';
import {EquipmentComponent} from './equipment/equipment.component';
import {EquipmentGlidersComponent} from './equipment-gliders/equipment-gliders.component';
import {EquipmentInstrumentsComponent} from './equipment-instruments/equipment-instruments.component';
import {AboutComponent} from './about/about.component';
import {AboutUsComponent} from './about-us/about-us.component';
import {ContactComponent} from './contact/contact.component';
import {PartnersComponent} from './partners/partners.component';
import {TcComponent} from './tc/tc.component';
import {DeploymentsMissionComponent} from "./deployments-mission/deployments-mission.component";
import {DevComponent} from "./dev/dev.component";
import {DeploymentsMonitoringComponent} from "./deployments-monitoring/deployments-monitoring.component";
import {DevDataStatusComponent} from "./dev-data-status/dev-data-status.component";

/**
 * name and title properties optional. If path has a value, name and title will be set automatically
 * (as 'path' and 'Path') respectively.
 */
let appRoutes: any[] =
  [
    { path: '', redirectTo: 'gliders', pathMatch: 'full' },
    {
      path: 'gliders', name: 'gliders',
      children: [
        { path: '', redirectTo: 'home', pathMatch: 'full' },
        { path: 'home', name: 'home', title: 'Home', component: HomeComponent },
        {
          path: 'data', name: 'data', title: 'Data', component: DataComponent,
          children: [
            { path: '', redirectTo: 'download', pathMatch: 'full' },
            {
              path: 'download', name: 'download', title: 'Download',
              children: [
                { path: '', redirectTo: 'all', pathMatch: 'full' },
                { path: 'all', name: 'download.all', title: 'Download', component: DataDownloadComponent },
                { path: ':deploymentNumber', name: 'download.selected', title: 'Download', component: DataDownloadComponent },
              ]
            },
            { path: 'plot', name: 'plot', title: 'Plot',
              children: [
                { path: '', redirectTo: 'all', pathMatch: 'full' },
                { path: 'all', name: 'plot.all', title: 'Plot', component: DataPlotComponent },
                { path: ':deploymentNumber', name: 'plot.selected', title: 'Plot', component: DataPlotComponent },
              ]
            },
            {
              path: 'interactivePlots', name: 'interactivePlots', title: '',
              children: [
                { path: '', redirectTo: 'all', pathMatch: 'full' },
                { path: 'all', name: 'interactive.all', title: 'Interactive Plots', component: DataPlotInteractiveComponent },
                { path: ':deploymentNumber', name: 'interactive.selected', title: 'Interactive Plots', component: DataPlotInteractiveComponent },
              ]
            }
          ]
        },
        {
          path: 'deployments', name: 'deployments', title: 'Deployments', component: DeploymentsComponent,
          children: [
            { path: '', redirectTo: 'all', pathMatch: 'full' },
            { path: 'all', name: 'deploymentList', title: 'All Deployments', component: DeploymentsAllComponent },
            { path: 'mission', name: 'mission', title: 'Mission', component: DeploymentsMissionComponent },
            {
              path: 'mission/:deploymentNumber', name: 'mission.selected', title: 'Mission', component: DeploymentsMissionComponent,
              children: [
                {
                  path: 'plots',
                  component: DeploymentsMissionComponent
                }
              ]
            },
            { path: 'monitoring', name: 'monitoring', title: 'Monitoring',
              children: [
                { path: '', redirectTo: 'all', pathMatch: 'full' },
                { path: 'all', name: 'monitoring.all', title: 'Monitoring', component: DeploymentsMonitoringComponent },
                { path: ':deploymentNumber', title: 'Monitoring', component: DeploymentsMonitoringComponent },
              ]
            }
          ]
        },
        {
          path: 'equipment', name: 'equipment', title: 'Equipment',
          component: EquipmentComponent,
          children: [
            { path: '', redirectTo: 'platforms', pathMatch: 'full' },
            { path: 'platforms', name: 'platforms', title: 'Platforms', component: EquipmentGlidersComponent },
            { path: 'instruments', name: 'instruments', title: 'Instruments', component: EquipmentInstrumentsComponent }
          ]
        },
        {
          path: 'about', name: 'about', title: 'About',
          component: AboutComponent,
          children: [
            { path: '', redirectTo: 'us', pathMatch: 'full' },
            { path: 'us', name: 'us', title: 'About Us', component: AboutUsComponent },
            { path: 'contact', name: 'contact', title: 'Contact Us', component: ContactComponent },
            { path: 'partners', name: 'partners', title: 'Partners', component: PartnersComponent },
            { path: 'tc', name: 'tc', title: 'Terms & Conditions', component: TcComponent }
          ]
        },
        { path: 'dev', name: 'dev', title: 'Dev', component: DevComponent,
          children: [
            { path: '', redirectTo: 'data-status', pathMatch: 'full' },
            { path: 'data-status', name: 'data-status', title: 'Dataset Status', component: DevDataStatusComponent }
          ]
        }
      ]
    }
  ];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, {onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule {

  constructor(router: Router, namedRoutesService: NamedRoutesService) {
    namedRoutesService.setRoutes(router.config);
  }

  getRoute(name): any {
    return this.searchRoutes(name, appRoutes)
  }

  private searchRoutes(name, routes): any {
    let result = null;
    routes.forEach((route) => {
      if(!result) {
        if(route.name == name) {
          result = route;
        } else if(route.children) {
          let childResult = this.searchRoutes(name, route.children);
          if(childResult) {
            result = childResult;
          }
        }
      }
    });
    return result;
  }
}
